module.exports = __webpack_public_path__ + "static/media/additionalInfo.dc28a2c1.png";